import { Box } from '@chakra-ui/react';
import { Header } from '../components/Header';
import { ServiceEditor } from '../components/ServiceEditor';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Editor = () => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <>
      <Box h={'66px'}>
        <Header
          headerText={
            location.pathname === '/add' ? t('new') : t('edit-service')
          }
          showBurger={false}
        />
      </Box>

      <Box mx={'21px'}>
        <ServiceEditor />
      </Box>
    </>
  );
};
